import { ObjectiveConfigState, ObjectiveType, ObjectiveConfigKey } from './objective.js';
import { UnknownAnchor } from './objective-package.js';
export class ObjectiveConfig implements ObjectiveConfigState {
    type: ObjectiveType = ObjectiveType.objective;
    key: ObjectiveConfigKey;
    constructor(
        public id: string,
        public name: string,
        public details: string,
        public points: number,
        public group: string,
        public pregame: boolean,
        public objectiveLinks?: UnknownAnchor[],
        public optional?: boolean,
        public sticky?: boolean,
        public icon?: string,
        public unicode?: string,
        key?: ObjectiveConfigKey | null,
        public disabled?: boolean,
        public dependsOn?: string | null
    ) {
        if (!points) {
            this.points = 0;
        }
        if (this.details === undefined) {
            this.details = 'No details';
        }
        this.key = { ...key } as ObjectiveConfigKey;
        this.optional = this.optional || false;
    }
    static fromState(state: ObjectiveConfigState, objectiveLinks?: UnknownAnchor[]) {
        return new ObjectiveConfig(
            state.id,
            state.name,
            state.details,
            state.points,
            state.group,
            state.pregame || false,
            objectiveLinks?.length ? objectiveLinks : undefined, // removes empty prop when sent by WS
            state.optional,
            state.sticky,
            state.icon,
            state.unicode,
            state.key,
            state.disabled,
            state.dependsOn
        );
    }
    toState(): ObjectiveConfigState {
        return {
            id: this.id,
            name: this.name,
            details: this.details,
            points: this.points,
            group: this.group,
            optional: this.optional,
            sticky: this.sticky,
            pregame: this.pregame,
            icon: this.icon,
            unicode: this.unicode,
            key: { ...this.key },
            disabled: this.disabled,
            dependsOn: this.dependsOn
        };
    }
}
